// extracted by mini-css-extract-plugin
export var root = "badge-module--root--9e7a2";